import { Col, Form, Row } from "react-bootstrap";
import { useEffect } from "react";
import { useCommonData } from "@/hooks/useCommonData";
import { FaultLogStatusList } from "@/shared/Enums";
import FormGroupMultiSelectOutside from "@/components/FormGroupMultiSelectOutside";
import { useSelector } from "react-redux";
import { RootState, store } from "@/redux/store";
import { UserProfileApi } from "@/services/UserProfile.api";
import { GetTerminalDisplayName } from "@/shared/models/Terminal";
import {
  setFilterRegionList,
  setFilterEndTime,
  setFilterProductList,
  setFilterStartTime,
  setFilterStatusList,
  setFilterTerminalList,
  setInitializationData,
} from "@/redux/dashboardSlice";

const FaultLogFilter = () => {
  const { terminals, products, regionOptions, loadCommonData } = useCommonData();
  const { apexId: currentApexId } = useSelector((state: RootState) => state.auth);
  const dashboardFilters = useSelector((state: RootState) => state.dashboard);

  useEffect(() => {
    const loadData = async () => {
      if (currentApexId && !dashboardFilters.isInitialized) {
        await loadCommonData();
        const profile = await UserProfileApi.getUserProfile(currentApexId);
        store.dispatch(
          setInitializationData({
            isInitialized: true,
            filterRegionList: profile?.region || [],
            filterTerminalList: profile?.primaryTerminalIds || [],
            filterProductList: profile?.productClassIds || [],
          })
        );
      }
    };

    loadData();
    // loadCommonData is stable (memoized with useCallback), safe to omit from deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentApexId, dashboardFilters.isInitialized]);

  return (
    <Row>
      <Col>
        <FormGroupMultiSelectOutside
          label="Region"
          placeHolder="Add a Region..."
          selectChanged={(e) => store.dispatch(setFilterRegionList(e))}
          defaultSelectedOptions={dashboardFilters.filterRegionList}
          options={regionOptions}
        ></FormGroupMultiSelectOutside>
      </Col>
      <Col xs={3}>
        <FormGroupMultiSelectOutside
          label="Terminal"
          placeHolder="Add a Terminal..."
          selectChanged={(e) => store.dispatch(setFilterTerminalList(e))}
          defaultSelectedOptions={dashboardFilters.filterTerminalList}
          options={terminals.map((terminal) => ({
            value: terminal.primaryTermicalId!.toString(),
            label: `${GetTerminalDisplayName(terminal)}`,
          }))}
        ></FormGroupMultiSelectOutside>
      </Col>
      <Col>
        <FormGroupMultiSelectOutside
          label="Products"
          placeHolder="Add a Products..."
          selectChanged={(e) => store.dispatch(setFilterProductList(e))}
          defaultSelectedOptions={dashboardFilters.filterProductList}
          options={products.map((prod) => ({ value: prod.productClass!.toString(), label: prod.displayProductName! }))}
        ></FormGroupMultiSelectOutside>
      </Col>
      <Col>
        <FormGroupMultiSelectOutside
          label="Status"
          placeHolder="Add a Status..."
          selectChanged={(e) => store.dispatch(setFilterStatusList(e))}
          defaultSelectedOptions={dashboardFilters.filterStatusList}
          options={Object.values(FaultLogStatusList).map((statusValue) => ({ value: statusValue, label: statusValue }))}
        ></FormGroupMultiSelectOutside>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            type="date"
            value={dashboardFilters.filterStartTime}
            onChange={(e) => store.dispatch(setFilterStartTime(e.target.value))}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>End Date</Form.Label>
          <Form.Control
            type="date"
            value={dashboardFilters.filterEndTime}
            onChange={(e) => store.dispatch(setFilterEndTime(e.target.value))}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default FaultLogFilter;
